import { getEnumValues } from "./get-enum-values";
import { CanadianPriceType } from "../test-payloads/graphql";

export const getCanadianPrices = () => getEnumValues(CanadianPriceType);
